/* src/app/home/cancel-request-modal/cancel-request-modal.component.scss */
.modal-header {
  border-bottom: none;
}
.modal-footer {
  border-top: none;
}
p {
  line-height: 13px;
}
.modal-title {
  font-size: 32px;
}
textarea {
  resize: none;
  width: 100%;
  border-radius: 0;
  min-height: 70px;
}
.cancel {
  width: 100%;
}
.cancel .modal-header,
.cancel .modal-body,
.cancel .modal-footer {
  padding-left: 0;
}
.cancel .close {
  padding-top: 20px;
  padding-right: 28px;
  font-size: 30px;
}
.cancel .modal-body {
  padding-top: 12px;
}
@media screen and (min-width: 992px) {
  .cancel {
    max-width: 900px !important;
    height: 177px;
    padding: 0 60px;
  }
  .cancel .modal-footer {
    padding-right: 32px;
  }
}
@media screen and (min-width: 768px) and (max-width: 991px) {
  .cancel {
    max-width: 724px !important;
    height: 177px;
    padding-left: 60px;
  }
  .cancel .modal-footer {
    padding-right: 54px;
  }
}
@media screen and (max-width: 767px) {
  .cancel {
    max-width: 318px !important;
    height: 194px;
    padding-left: 33px;
  }
  .cancel .modal-footer {
    padding-right: 32px;
  }
}
.btn-green {
  color: white;
  background-color: #00857D;
  border-radius: 35px;
  width: 97px;
  height: 36px;
}
.btn-white {
  color: #00857D;
  background-color: white;
  border-radius: 35px;
  border: thin #00857D solid;
  width: 97px;
  height: 36px;
}
.error {
  color: red;
}
.t-error::placeholder {
  color: red;
  font-size: 1.5em;
  text-align: right;
  font-weight: bold;
}
.t-error {
  border-color: red;
}
/*# sourceMappingURL=cancel-request-modal.component.css.map */
